import { mountReactComponents } from "../helpers/mountReactComponents";

const splashComponentContext = require.context("../splash_components", true);

document.addEventListener("DOMContentLoaded", () => {
  mountReactComponents(splashComponentContext);
});
